import { useEffect, useState } from "react";
import { Form, InputGroup, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import StockUpdateModal from "./StockUpdateModal";
import { globalAlert, globalLoader } from "../../../../actions/commonActions";
import { adminOnlineProductStockUpdateApi, adminOnlineProductToggleApi } from "../../../../admin/_actions";
import { logOut } from "../../../../_shared/commonFunction";
import ConfirmDeactivateModal from "../ConfirmDeactivateModal";

const ProductsTable = ({ products, history, callBasicApi }) => {
    const { t } = useTranslation();
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [showStockUpdateModal, setShowStockUpdateModal] = useState(false);
    const [stockUpdateReason, setStockUpdateReason] = useState(null);
    const [stockUpdateQuantity, setStockUpdateQuantity] = useState("");
    const [orgProduct, setOrgProduct] = useState(null);
    const [showToggleModal, setShowToggleModal] = useState(false);

    const toggleMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    useEffect(() => {
        const handleClickOutside = () => {
            if (openMenuIndex !== null) setOpenMenuIndex(null);
        };
        window.addEventListener("click", handleClickOutside);
        return () => window.removeEventListener("click", handleClickOutside);
    }, [openMenuIndex]);

    useEffect(() => {
        console.log(`stockUpdateQuantity`, stockUpdateQuantity);
    }, [stockUpdateQuantity]);

    const stockUpdateApi = async () => {
        try {
            globalLoader(true);
            const res = await adminOnlineProductStockUpdateApi(orgProduct?.orgProductId, { quantity: stockUpdateQuantity, notes: stockUpdateReason });
            if (res?.data?.status === 200) {
                globalAlert("success", res?.data?.message);
                await callBasicApi();
            } else {
                globalAlert("error", res?.data?.message);
            }
            globalLoader(false);
        } catch (error) {
            globalAlert("error", error?.response?.data?.message);
            if (error?.response?.data?.status === 401) {
                logOut(history, "/admin/login");
            }
            globalLoader(false);
        }
    }

    const toggleProductApi = async () => {
        try {
            globalLoader(true);
            const res = await adminOnlineProductToggleApi(orgProduct?.orgProductId);
            if (res?.data?.status === 200) {
                globalAlert("success", res?.data?.message);
                await callBasicApi();
            } else {
                globalAlert("error", res?.data?.message);
            }
            globalLoader(false);
        } catch (error) {
            globalAlert("error", error?.response?.data?.message);
            if (error?.response?.data?.status === 401) {
                logOut(history, "/admin/login");
            }
            globalLoader(false);
        }
    }


    const handleStockUpdateConfirm = async () => {
        await stockUpdateApi();
        resetStokcUpdateState();
    };
    const resetStokcUpdateState = () => {
        setShowStockUpdateModal(false);
        setStockUpdateReason("");
        setStockUpdateQuantity(null);
        setOrgProduct(null);
    };
    const handleShowStockUpdateModal = (quantity, orgProduct) => {
        setOrgProduct(orgProduct);
        setStockUpdateQuantity(null);
        setShowStockUpdateModal(true);
    };

    const handleShowToggleModal = (orgProduct) => {
        setOrgProduct(orgProduct);
        setShowToggleModal(true);
    };
    const handleToggleConfirm = async () => {
        await toggleProductApi();
        setOrgProduct(null);
        setShowToggleModal(false);
    };
    return (
        <>
        {showToggleModal && <ConfirmDeactivateModal
            show={showToggleModal}
            onClose={() => setShowToggleModal(false)}
            onConfirm={handleToggleConfirm}
            isActive={orgProduct?.inOnlineStore}
            suffixMsg="Product"
        />}
        {showStockUpdateModal && <StockUpdateModal
        show={showStockUpdateModal}
        onClose={() => resetStokcUpdateState()}
        onConfirm={handleStockUpdateConfirm}
        reason={stockUpdateReason}
        setReason={setStockUpdateReason}
        quantity={stockUpdateQuantity}
        setQuantity={setStockUpdateQuantity}
      />}
            {/* Search */}
            {/* <InputGroup className="mb-3">
                <Form.Control placeholder="Search" className="search-input" />
            </InputGroup> */}

            {/* Table */}
            <Table bordered className="table-orders">
                <thead>
                    <tr>
                        <th>{t("common.serialNo")}</th>
                        <th>{t("admin.orders.table.productName")}</th>
                        <th>{t("admin.onlineProducts.productImage")}</th>
                        <th>{t("common.quantity")}</th>
                        <th>{t("common.status")}</th>
                        <th>{t("common.action")}</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((p, idx) => (
                        <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{p?.name}</td>
                            <td>
                                <img src={p?.image} width={30} alt={t("common.product")} className="product-img" />
                            </td>
                            <td>
                                {p?.stockQuantity}
                            </td>
                            <td>
                                <span className={p?.inOnlineStore ? "text-success" : "text-muted"}>
                                    {p?.inOnlineStore ? t("common.active") : t("common.inactive")}
                                </span>
                            </td>
                            <td className="position-relative text-center">
                                <div className="dropdown-wrapper" onClick={(e) => e.stopPropagation()}>
                                    <i
                                        className="fa fa-ellipsis-v cursor-pointer"
                                        onClick={() => toggleMenu(idx)}
                                    ></i>

                                    {openMenuIndex === idx && (
                                        <div className="action-dropdown">
                                            <div className="action-item" onClick={() => handleShowToggleModal(p)}><i className="fa fa-solid fa-circle mr-2" style={{ fontSize: '6px' }}></i>{p?.inOnlineStore ? t("common.deactivate") : t("common.activate")}</div>
                                            <div className="action-item" onClick={() => handleShowStockUpdateModal(p?.stockQuantity, p)}><i className="fa fa-solid fa-circle mr-2" style={{ fontSize: '6px' }}></i>{t("common.updateStock")}</div>
                                        </div>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    )
}

export default ProductsTable;